import ResponseTypeMasterContainer from '../../containers/responseTypeMaster/responseTypeMaster';

function ResponseTypeMaster() {
  return <ResponseTypeMasterContainer />;
}

export default ResponseTypeMaster;
